module.exports = __webpack_public_path__ + "static/media/16.c18a0cf0.jpg";